import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import BaseMoneyField from 'modules/core/components/MoneyField'

export type MoneyFieldProps = React.ComponentProps<typeof BaseMoneyField> & {
  field: Field
  onChange?: (field: Field) => void
}

const MoneyField = ({
  error,
  field,
  value,
  readonly,
  mandatory,
  onChange,
  ...props
}: MoneyFieldProps) => {
  const handleChange = (date: string) => {
    if (!field) return

    field.set(date)
    onChange?.(field)
  }

  return (
    <BaseMoneyField
      {...props}
      readonly={readonly}
      mandatory={mandatory && !readonly}
      onChange={handleChange}
      value={value || field.value || ''}
      error={error || undefined}
      changeOnBlur={field.isDirty}
    />
  )
}

export default observer(MoneyField)
